import React, {FC} from 'react';
import {Button, CopyField} from '../Components';
import {IMcpToken} from '../react-sdk/queries';
import {CONFIG} from '../config';
import {Dialog} from './Dialog';

interface CreatedMcpTokenDialogProps {
  onClose: () => void;
  token: IMcpToken;
  rotated?: boolean;
}

export const CreatedMcpTokenDialog: FC<CreatedMcpTokenDialogProps> = ({onClose, token, rotated = false}) => {
  const secret = token.token || '';
  const claudeCode = `claude mcp add --transport http verdocs ${CONFIG.MCP_URL} --header "Authorization: Bearer ${secret}"`;
  const httpConfig = JSON.stringify(
    {mcpServers: {verdocs: {type: 'http', url: CONFIG.MCP_URL, headers: {Authorization: `Bearer ${secret}`}}}},
    null,
    2,
  );
  const stdioConfig = JSON.stringify(
    {mcpServers: {verdocs: {command: 'npx', args: ['-y', 'mcp-remote', CONFIG.MCP_URL, '--header', `Authorization: Bearer ${secret}`]}}},
    null,
    2,
  );

  return (
    <Dialog onCancel={onClose} size="lg">
      <div className="overflow-y-auto">
        <div className="mb-4 text-lg font-medium text-[#33364b]">{rotated ? `New token for ${token.name}` : `${token.name} is ready`}</div>

        <div className="mb-4 rounded-md border border-[#f0d9b5] bg-[#fdf8ef] p-3 text-[12px] leading-snug text-[#95591a]">
          {rotated
            ? "The previous token is no longer valid. Update your assistant's configuration now to avoid disruption."
            : 'Copy this code and store it somewhere safe. This is the only time it will be shown.'}
        </div>

        <CopyField label="Token" value={secret} />
        <CopyField label="Claude Code" value={claudeCode} multiline />
        <CopyField label="Claude Desktop, Cursor, and other clients" value={httpConfig} multiline />
        <CopyField label="Command-line tools" value={stdioConfig} multiline hint="Runs the server through mcp-remote." />

        <div className="mt-2 flex justify-end">
          <Button size="small" label="Done" onClick={onClose} />
        </div>
      </div>
    </Dialog>
  );
};
